var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7C9.88627 7 10.334 7.44772 10.334 8C10.334 8.51284 9.94794 8.93551 9.45061 8.99327L9.33398 9H7.33398C5.67713 9 4.33398 10.3431 4.33398 12C4.33398 13.5977 5.5829 14.9037 7.15771 14.9949L7.33398 15H9.33398C9.88627 15 10.334 15.4477 10.334 16C10.334 16.5128 9.94794 16.9355 9.45061 16.9933L9.33398 17H7.33398C4.57256 17 2.33398 14.7614 2.33398 12C2.33398 9.31125 4.45629 7.11818 7.11709 7.00462L7.33398 7H9.33398ZM17.334 7C20.0954 7 22.334 9.23858 22.334 12C22.334 14.6888 20.2117 16.8818 17.5509 16.9954L17.334 17H15.334C14.7817 17 14.334 16.5523 14.334 16C14.334 15.4872 14.72 15.0645 15.2174 15.0067L15.334 15H17.334C18.9908 15 20.334 13.6569 20.334 12C20.334 10.4023 19.0851 9.09634 17.5103 9.00509L17.334 9H15.334C14.7817 9 14.334 8.55228 14.334 8C14.334 7.48716 14.72 7.06449 15.2174 7.00673L15.334 7H17.334ZM7.33398 11H17.334C17.8863 11 18.334 11.4477 18.334 12C18.334 12.5128 17.9479 12.9355 17.4506 12.9933L17.334 13H7.33398C6.7817 13 6.33398 12.5523 6.33398 12C6.33398 11.4872 6.72002 11.0645 7.21736 11.0067L7.33398 11H17.334H7.33398Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.245f418d5c7b281ea7d73bb0d2624156.svg";
export { ForwardRef as ReactComponent };